<template>
<div>
  <p v-if="preloaderProcess" class="text-center">
      Este proceso puede llevar un tiempo. <br />
      <span class="font-weight-bold">Procesando: {{ loading }}% </span> 
    </p>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Documentación - Renovación"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6" v-if="inputs.status && inputs.status.code == 108">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openProcessModal"
          >
            Procesar
          </button>
        </div>
      </div>
      <form
        ref="form"
        data-url="/complianceCommitment"
        :class="{ 'loading-opacity': preloader }"
        enctype="multipart/form-data"
      >

        <div class="col-12 mt-3">
          <p v-html="tag61"></p>
        </div>

        <div class="col-12">
          <app-note
          class="mb-primary"
          :show-title="false"
          :notes="['Todos los campos con un (*) son obligatorios.']"
        />
        </div>

        <div class="col-md-12">
          <table id="compliance-commitment">
            <tr v-for="(value, key) in complianceData" :key="key">
              <td class="name">
                {{ value.compliance_commitment.name }}
                <b
                  v-if="value.compliance_commitment.is_required"
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*</b
                >
              </td>
              <td class="is-checked">
                <input
                  type="checkbox"
                  v-model="value.is_checked"
                  :disabled="check_compliance"
                />
              </td>
            </tr>
          </table>
        </div>

        <div class="col-12 mt-3">
          <p v-html="$store.getters.getTag('6.D.R')"></p>
        </div>
        
        <div class="col-12">
          <div class="form-group">
            <!-- <label>
              Documento de compromiso firmado
              <strong class="text-danger">*</strong>
            </label>
            <app-input
              type="file"
              :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
              v-model="inputs.file"
              v-if="!inputs.renewal_compliance_document"
            />
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'renewal_compliance_document')"
                v-if="inputs.renewal_compliance_document"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('renewal_compliance_document')"
                v-if="inputs.renewal_compliance_document"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div> -->
            <div class="row" v-if="inputs.status && inputs.status.code == 108">
              <div class="col-12 mt-3">
                <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="submit"
                >
                  {{ $t("save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="process"
      @cancelled="cancelledRe"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>

</div>

</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
export default {
  name: "RenovationDocument",
  mixins: [FormMixin],
  props: {
    evalTestId: String,
  },
  data() {
    return {
      preloader: false,
      preloaderProcess: false,
      deleteModal: false,
      selected: "",
      inputs: {},
      accApp: {},
      complianceData: {},
      accInit: {},
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      idAcc: 0,
      check_compliance: false,
      loading: 0,
    };
  },
  computed: {
    org() {
      return this.accApp ? this.accApp : null;
    },

    user() {
      return this.accApp ? this.accApp.user : null;
    },

    accAppInt() {
      return this.accInit ? this.accInit : null;
    },

    tag61() {
      let tmp = this.$store.getters.getTag("6.1.R");

      const lr = { name: "_____", taxid: "_____" };
      if (this.accApp.id) {
        if (this.org && this.org.legal_representative) {
          lr.name = this.org.legal_representative;
          lr.taxid = this.org.legal_representative_taxid;
        } else {
          lr.name = `${this.user.first_name} ${this.user.last_name}`;
          lr.taxid = this.user.taxid;
        }
      }
      tmp = tmp.replace("[name]", lr.name);
      tmp = tmp.replace("[taxid]", lr.taxid);
      tmp = tmp.replace(
        "[oc]",
        this.org
          ? this.org.business_name
            ? this.org.business_name
            : "_____"
          : "_____"
      );
      tmp = tmp.replace("[record]", this.inputs?.record ? this.inputs.record : "_____");
      tmp = tmp.replace("[resolution_number]", this.accAppInt?.resolution_number ? this.accAppInt.resolution_number : "_____");
      tmp = tmp.replace("[resolution_date]", this.accAppInt?.resolution_date ? this.accAppInt.resolution_date : "_____");
      return tmp;
    },
  },
  created() {
    this.$store.dispatch("getTagsByActivity", {
      accAppId: this.evalTestId,
    });
    this.getData();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      let formData = new FormData();
      let i = 0;
      let j = 0;
      for (let index = 0; index < this.complianceData.length; index++) {
        formData.append("id[]", this.complianceData[index].id);
        formData.append(
          "is_checked[]",
          this.complianceData[index].is_checked ? 1 : 0
        );
        i += this.complianceData[index].is_checked ? 1 : 0;
        j += this.complianceData[index].compliance_commitment.is_required ? 1 : 0;
      }
      /* if (i != j) {
        this.$toastr.e(
          "Debe seleccionar los compromisos que son obligatorios (*)"
        );
        return;
      } */
      // formData.append("file", this.inputs.file);
      // if (this.delete_file) {
      //   formData.append("delete_file", true);
      // }
      formData.append(
        "accreditation_application_id",
        this.evalTestId
      );
      this.save(formData);
      
    },
    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.preloader = false;
      this.inputs = res.data.data;
      this.getData();
      this.$toastr.s(this.$t("complaint_success"));
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
    },
    cancelled() {
      this.deleteModal = false;
    },
    openProcessModal() {
      this.deleteConfirmationModalActive = true;
    },
    cancelledRe() {
      this.deleteConfirmationModalActive = false;
    },
    async getData() {
      this.preloader = true;
      try {
        let url = `/accreditations/process/renovation/show/${this.evalTestId}`;
        let urlInit = `/accreditations/process/renovation/showInit/${this.evalTestId}`;
        let urlCompliance = `/complianceCommitment/show?accreditation_application_id=${this.evalTestId}`;
        let urlAcc = `/accreditations/process/renovation/showAccApp/${this.evalTestId}`;

        const [response1, response2, response3, response4] = await Promise.all([
              this.axiosGet(url),
              this.axiosGet(urlInit),
              this.axiosGet(urlCompliance),
              this.axiosGet(urlAcc)
        ]);

        this.inputs = response1.data;
        if (this.inputs.status.code != '108') {
            this.check_compliance = true;
        }
        this.idAcc = response1.data.id;

        this.accApp = response2.data;

        this.complianceData = response3.data;

        this.accInit = response4.data;

      } catch (error) {
        console.error(error);
      } finally {
        this.preloader = false;
    }
    },
    process() {
      this.preloaderProcess = true;
      this.preloader = true;
      let url = `/accreditations/process/renovation/processRenovation?idAcc=${this.idAcc}`;
      let options = {
        method: 'POST',
        url: url,
      }
      if(this.inputs.is_save_lots){
        options.url = options.url + `&page=${this.inputs.next_lot}`;
      }

      let attempts = 0;
      async function request(options,toastr,loading,num = 0){
        let info = null;
        try{
            const response = await axios.request(options);
            info = await response.data;
            
            if(info.message === 'B'){
              return;
            }
            if(info.message === 'noChecked'){
              throw Error('No se han aceptado todos los compromisos de cumplimiento');
            }

            if(info.finally){
              throw Error(info.message);
            }

            if(info.page === info.lastPage){
              return;
            }

            if(!info.repeat){
                if(num > 1){
                  options.url = options.url.replace(/\&page=[0-9]+/,`&page=${info.page + 1}`);
                }else {
                  options.url = url + `&page=${ info.page + 1}`;
                }
                return request(options,toastr,loading,info.page);
            }else{
                attempts++;
                if(attempts === 5){
                  throw Error('Error desconocido, por favor intentelo mas tarde.');
                  return;
                }
                return request(options,toastr,loading);
            }
        }catch(e){
          throw Error(e.message);
          return;
        }finally{
          loading(info.porcent);
        }
      }

      request(options,this.$toastr,setLoading,this.inputs.is_save_lots ? this.inputs.next_lot : 0)
      .then(() => {
        this.$toastr.s(this.$t("complaint_success"));
        this.returnPage();
      })
      .catch(e => {
        this.$toastr.e(e.message);
      })
      .finally(() => {
        this.preloaderProcess = false;
        this.preloader = false;
      });

      const self = this;
      function setLoading(porcent){
        self.loading = porcent;
      }
    },
    returnPage() {
      window.location.href = `/accreditations/process/renovation?tab=Documento%20Renovación`;
    },
  },
};
</script>

<style>
#compliance-commitment {
  width: 100%;
}
#compliance-commitment tr {
  border: 1px dotted gray;
}
#compliance-commitment td {
  padding: 0.8rem;
}
#compliance-commitment .name {
  text-align: justify;
}
#compliance-commitment .is-checked {
  width: 5%;
  text-align: center;
}
</style>
